import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@modules/shared/shared.module';
import { NgZorroAntdModule } from '@public-page/ng-zorro-antd/ng-zorro-antd.module';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActionsSubject, Store } from '@ngrx/store';
import { AuthorizationActions, AuthorizationApiActions } from '@modules/authorization/store/auth';
import { ofType } from '@ngrx/effects';
import { Subject, takeUntil } from 'rxjs';
import { BaseForm } from '@modules/core/abstract-classes';
import { ModelFormGroup } from '@modules/core/types';
import { ConfirmNewPasswordPayload, ResetPasswordForm } from '@modules/core/interfaces';

@Component({
  selector: 'pub-reset-password-page',
  standalone: true,
  imports: [CommonModule, NgZorroAntdModule, SharedModule, FormsModule, ReactiveFormsModule],
  templateUrl: './reset-password-page.component.html',
  styleUrls: ['./reset-password-page.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordPageComponent extends BaseForm implements OnInit, OnDestroy {
  form!: FormGroup<ModelFormGroup<ResetPasswordForm>>;
  showResetPasswordInfo = true;
  destroy$ = new Subject();

  constructor(private store: Store, private actionsListener$: ActionsSubject, private cdRef: ChangeDetectorRef) {
    super('initResetPasswordForm');
  }

  ngOnInit(): void {
    this.store.dispatch(AuthorizationActions.verifyResetPassword());

    this.actionsListener$
      .pipe(ofType(AuthorizationApiActions.verifyResetPasswordFailure))
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.showResetPasswordInfo = false;
        this.cdRef.detectChanges();
      });
  }

  confirmNewPassword(): void {
    if (this.form.valid) {
      this.store.dispatch(
        AuthorizationActions.confirmNewPassword({
          payload: { password: this.form.value.password } as ConfirmNewPasswordPayload,
        })
      );
    } else {
      this.checkValidation();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
